import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import {
  cellStyles4,
  Columns,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
export const utilizationProviderConstants = {
  breadCrumbsConstant: [
    [
      'text',
      'Utilization Summary',
      {
        color: patientAccessTheme.palette.primary[500],
        fontWeight: 500,
      },
    ],
    [
      'text',
      'Provider Utilization',
      {
        color: patientAccessTheme.palette.text.highemphasis,
        fontWeight: 600,
      },
    ],
  ],
};

export const TopFacilityColumns: Columns[] = [
  {
    name: 'Facility',
    align: 'left',
    cellStyles: cellStyles4,
    width: '350px',
  },
  {
    name: 'Claims',
    align: 'center',
    cellStyles: cellStyles4,
    width: '80px',
  },
  {
    name: 'Total Cost',
    align: 'right',
    cellStyles: cellStyles4,
    width: '151px',
  },
  {
    name: 'Plan Paid',
    align: 'right',
    cellStyles: cellStyles4,
    width: '147px',
  },
  // {
  //   name: 'Plan Paid Share',
  //   align: 'right',
  //   cellStyles: cellStyles4,
  //   width: '136px',
  // },
];

export const TopPhysicansColumns: Columns[] = [
  {
    name: 'Physician',
    align: 'left',
    cellStyles: cellStyles4,
    width: '350px',
  },
  {
    name: 'Claims',
    align: 'center',
    cellStyles: cellStyles4,
    width: '80px',
  },
  {
    name: 'Total Cost',
    align: 'right',
    cellStyles: cellStyles4,
    width: '151px',
  },
  {
    name: 'Plan Paid',
    align: 'right',
    cellStyles: cellStyles4,
    width: '147px',
  },
  // {
  //   name: 'Plan Paid Share',
  //   align: 'right',
  //   cellStyles: cellStyles4,
  //   width: '136px',
  // },
];
